import React, { Component } from 'react';
import { connect } from 'react-redux';
import clone from 'fast-clone';
import {
    getPublicLeagueLeaderBoardData,
    getPublicLeagueLeaderBoardRankData,
} from './../../actions/LeagueActions';
import {
    getFixtures,
} from './../../actions/ManageTeamActions';
import { addFixturesStatus } from './../../helper'
import { concat, filter, uniqBy, find } from 'lodash';
import OutsideNotifier from '../../OutsideNotifier';
import config from './../../config';
import common from './../../common';
import apiError from './../../constants/api-error';
import GeneralPopUp from './../GeneralPopUp';
import routeObject from '../../constants/new-pageTrackEvents'
import AdBottom from '../AdBottom';

class PublicLeaderBoard extends Component {
    setInitialState = () => {
        this.setState({
            Rest: [],
            Self: [],
            userSpecificFixtures: [],
            isDDOpen: false,
            currentActiveFixture: 0,
            popupProps: {
                message: '',
                inlineMessage: '',
                popupWrapperClass: '',
                iconClass: '',
                showPopup: false,
            },
            showToolTip: false,
            showAchievementsToolTip: false,
        });
        this.pageNumber = 1;
        this.vPageChunk = common.isMobile() ? 20 : 25;
        this.defaultFilter = {
            isOverAll: true,
        };
        this.reqInput = [0, 0, 1];
    };

    componentWillMount() {
        this.setInitialState();
    }

    componentDidMount() {
        this.getLeaderBoard();
        this.getRank();
        this.props.getFixtures().then(() => {
            const { fixtures } = this.props;
            const { TypeID, countryID, clubID } = this.props.match.params;
            const fixturesWithStatus = addFixturesStatus(fixtures);
            let allowedStatus = [config.fixtureStatus.isFinished, config.fixtureStatus.isSubstitution];
            let filteredFixtures = filter(fixturesWithStatus, (fixture) => {
                // return allowedStatus.indexOf(fixture.status) > -1;
                if (TypeID == 4) {
                    return fixture.GDID >= config.knockoutGDID && fixture.ShowLeaderboards == 1;
                } else {
                    return fixture.ShowLeaderboards == 1
                }

            });

            if (filteredFixtures.length == 0) {
                filteredFixtures = filter(fixturesWithStatus, (fixture) => {
                    // return allowedStatus.indexOf(fixture.status) > -1;

                    return fixture.ShowLeaderboards == 1

                });
            }
            let uniquePhaseIDs = uniqBy(filteredFixtures, (a) => {
                return a['PhID'];
            });
            let uniqueMDIDs = uniqBy(filteredFixtures, (a) => {
                return a.GDID;
            });
            uniquePhaseIDs = clone(uniquePhaseIDs).map(el => {
                el.isPhase = true;
                return el;
            });
            uniqueMDIDs = clone(uniqueMDIDs).map(el => {
                el.isMDID = true;
                return el;
            });
            let userSpecificFixtures = concat(this.defaultFilter, uniquePhaseIDs, uniqueMDIDs);



            if (TypeID == 1) {
                //global
                common.pageViewTracking("", routeObject["globalRank"]);
            } else if (TypeID == 2) {
                //country
                var obj = routeObject["country"];
                obj["pageName"] = obj["pageName"].replace("{country}", countryID)
                common.pageViewTracking("", obj);
            } else if (TypeID == 3) {
                //clucb
                var obj1 = routeObject["club"];
                obj1["pageName"] = obj1["pageName"].replace("{club}", clubID)
                common.pageViewTracking("", routeObject["club"]);
                common.pageViewTracking("", obj1);
            } else {
                //knockout
                var obj1 = routeObject["knockout"];
                obj1["pageName"] = obj1["pageName"].replace("{knockout}", clubID)
                common.pageViewTracking("", routeObject["club"]);
                common.pageViewTracking("", obj1);
                userSpecificFixtures = concat(this.defaultFilter, uniqueMDIDs);
            }
            const publicLeagues = common.getLocalStorage('publicLeagues') || [];
            const leagueObj = find(publicLeagues, { TypeId: +TypeID });
            let currLeader = leagueObj.LeagueName || "";
            this.setState({ userSpecificFixtures, currLeader });
        });
    }

    getLeaderBoard = () => {
        const { TypeID, countryID, clubID } = this.props.match.params;
        if (!TypeID) return;
        const phaseID = this.reqInput[0] || 0;
        const gamedayId = this.reqInput[1] || 0;
        const opType = this.reqInput[2] || 1;
        common.showLoader();
        this.props.getPublicLeagueLeaderBoardData(opType, this.pageNumber, this.vPageChunk, this.vPageChunk,
            TypeID, countryID, clubID, phaseID, gamedayId).then(() => {
                common.hideLoader();
                const response = this.props.publicLeaderBoard;
                const errorKeyFromTrans = apiError.leagues;
                const message = this.props.trans[errorKeyFromTrans];
                if (!response) {
                    let stateToSet = {
                        message,
                        popupWrapperClass: 'si-error-popup',
                        iconClass: 'icon-ucl-close',
                        showPopup: true
                    };
                    this.handleToast(stateToSet);
                } else {
                    const { Rest } = this.state;
                    const mergedRest = concat(Rest, response);
                    let areAllLoaded = false;
                    if (response.length < this.vPageChunk) {
                        areAllLoaded = true;
                    }
                    if (this.pageNumber == config.maxLeaderboardPages) {
                        areAllLoaded = true;
                    }

                    this.setState({ Rest: mergedRest, areAllLoaded });
                    ++this.pageNumber;
                }
            });
    };
    getRank = () => {
        const { TypeID, countryID, clubID } = this.props.match.params;
        if (!TypeID) return;
        const phaseID = this.reqInput[0] || 0;
        const gamedayId = this.reqInput[1] || 0;
        const opType = this.reqInput[2] || 1;
        common.showLoader();
        this.props.getPublicLeagueLeaderBoardRankData(opType, this.pageNumber, this.vPageChunk, this.vPageChunk,
            TypeID, countryID, clubID, phaseID, gamedayId).then(() => {
                common.hideLoader();
                const response = this.props.publicRankLeaderBoard;
                const errorKeyFromTrans = apiError.leagues;
                const message = this.props.trans[errorKeyFromTrans];
                if (!response) {
                    let stateToSet = {
                        message,
                        popupWrapperClass: 'si-error-popup',
                        iconClass: 'icon-ucl-close',
                        showPopup: true
                    };
                    this.handleToast(stateToSet);
                } else {
                    this.setState({ Self: response });
                }
            });
    };
    handleToast = (popupState) => {
        this.setState({ popupProps: popupState });
    };
    resetToast = () => {
        this.handleToast({ popupProps: { showPopup: false, message: '' } });
    };
    onDDTap = () => {
        this.setState(prevState => ({
            isDDOpen: !prevState.isDDOpen,
        }));
    };
    onPreviousTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: --currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onNextTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: ++currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onSelect = (currentActiveFixture) => {
        this.setState({ currentActiveFixture, isDDOpen: !this.state.isDDOpen });
        this.getRespectiveData(currentActiveFixture);
    };
    getRespectiveData = (currentActiveFixture) => {
        const { userSpecificFixtures } = this.state;
        const el = userSpecificFixtures[currentActiveFixture];
        this.reqInput = el.isOverAll ? [0, 0, 1] :
            el.isMDID ? [0, el['GDID'], 2] :
                el.isPhase ? [el['PhID'], 0, 3] : [0, 0, 1];
        this.pageNumber = 1;
        this.setState({ Rest: [], Self: [] });
        this.getLeaderBoard();
        this.getRank();
    };
    onBackClick = () => {
        return this.props.history.goBack();
    };
    onTooltipOutsideClick = () => {
        this.setState((previousState) => {
            return { showToolTip: !previousState.showToolTip };
        });
    };
    onAchievementsTooltipOutsideClick = () => {
        this.setState((previousState) => {
            return { showAchievementsToolTip: !previousState.showAchievementsToolTip };
        });
    };
    goToSettings = (leagueID) => {
        common.customTracking('League Settings');
        return this.props.history.push('/league-settings/' + leagueID);
    };

    getText(TotalMembers) {
        const membersCount = config.MEMBERS_COUNT_REQUIRED_FOR_ACHIEVEMENTS - TotalMembers;
        const updatedHTML = this.props.trans['MEMBERS_COUNT_FOR_ACHIEVEMENTS'].replace('{HREF}', '#').replace('{MEMBERS}', membersCount);
        return { __html: updatedHTML };
    }

    goToTeam = (GUID, UserId, UserTeamId) => {
        if (GUID == "self") {
            // return this.props.history.push("/manage-team");
            return "/" + config.CURRENT_LANGUAGE + "/uclfantasy/manage-team";
        } else {
            // return this.props.history.push(`/team/${GUID}/${UserId}/${UserTeamId}/${this.reqInput[1]}/${this.reqInput[0]}`);
            return `/${config.CURRENT_LANGUAGE}/uclfantasy/team/${GUID}/${UserId}/${UserTeamId}/${this.reqInput[1]}/${this.reqInput[0]}`
        }

    };

    render() {
        const { trans } = this.props;
        const { Rest, Self, userSpecificFixtures, currentActiveFixture, areAllLoaded, showToolTip, popupProps, currLeader } = this.state;
        const { showPopup, message, popupWrapperClass, iconClass, isToast } = popupProps;
        if (Rest.length === 0) return null;
        const popupPropsData = {
            showPopup,
            resetToast: this.resetToast,
            message,
            isToast,
            wrapperClass: popupWrapperClass,
            iconClass: iconClass
        };
        if (userSpecificFixtures.length === 0) return null;
        const mDiD = userSpecificFixtures.filter(fixture => fixture.isMDID);
        const mDiDToDisplay = mDiD[mDiD.length - 1];
        const matchDayTrans = trans['matchday'];
        const phaseTrans = trans['phase'];
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
        // const selectedLabel = selectedMatchDay.isOverAll ? trans['overall'] :
        //     selectedMatchDay.isMDID ? matchDayTrans + ' ' + selectedMatchDay['GDID'] :
        //         selectedMatchDay.isPhase ? phaseTrans + ' ' + selectedMatchDay['PhID'] : null;
        let selectedLabel = null
        if (selectedMatchDay.isOverAll) {
            selectedLabel = trans['overall'] ? trans['overall'] : 'Overall';
        }
        if (selectedMatchDay.isMDID) {
            selectedLabel = trans['rd' + selectedMatchDay['GDID']]
                ? trans['rd' + selectedMatchDay['GDID']]
                : matchDayTrans + ' ' + selectedMatchDay['GDID'];
        }
        if (selectedMatchDay.isPhase) {
            selectedLabel = trans['ph' + selectedMatchDay['PhID']]
                ? trans['ph' + selectedMatchDay['PhID']]
                : phaseTrans + ' ' + selectedMatchDay['PhID'];
        }
        // const selectedLabel = selectedMatchDay.isOverAll
        // ? trans['overall']
        // : selectedMatchDay.isMDID
        // ? trans['rd' + selectedMatchDay['GDID']]
        // : selectedMatchDay.isPhase
        // ? trans['ph' + selectedMatchDay['PhID']]
        // : null;
        const isFirst = currentActiveFixture === 0;
        const isLast = currentActiveFixture === (userSpecificFixtures.length - 1);
        const prevBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_right': true,
            'si-disabled': isFirst
        });
        const nextBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_left': true,
            'si-disabled': isLast
        });
        const members = Rest || [];
        const isUserInRest = find(Rest, (el) => {
            return el.GUID === common.getGUID();
        });
        const tooltipClass = common.makeClasses({
            'si-tooltip-wrp': true,
            'si-active': showToolTip
        });
        let TotalMember = 0;
        if (members && members.length) {
            TotalMember = members[0].TotalMember
        }

        // const columnLabel = (selectedMatchDay.isPhase || selectedMatchDay.isMDID) ? (selectedLabel) : ((mDiDToDisplay && mDiDToDisplay['GDID']) ? trans['matchday'] + ' ' + mDiDToDisplay['GDID'] : '-');

        let columnLabel = null;
        if (selectedMatchDay.isOverAll) {
            columnLabel = trans['MD' + mDiDToDisplay['GDID']]
                ? trans['MD' + mDiDToDisplay['GDID']]
                : matchDayTrans + ' ' + mDiDToDisplay['GDID'];
        }
        if (selectedMatchDay.isMDID) {
            columnLabel = trans['MD' + selectedMatchDay['GDID']]
                ? trans['MD' + selectedMatchDay['GDID']]
                : matchDayTrans + ' ' + selectedMatchDay['GDID'];
        }
        if (selectedMatchDay.isPhase) {
            columnLabel = trans['phaseShort' + selectedMatchDay['PhID']]
                ? trans['phaseShort' + selectedMatchDay['PhID']]
                : phaseTrans + ' ' + selectedMatchDay['PhID'];
        }

        return <div className="si-main-component si-manage-team si-no-anim si-leagues">
            <div className="si-container si-leaderboard-pg">
                <div className="si-top-section">
                    <div className="si-leagues-header si-flexBox">
                        <div className="si-back-btn si-cols">
                            <i className="icon-ucl-back_arrow si-display-block" onClick={ () => this.onBackClick() } />
                        </div>
                        <div className="si-cols si-header-txt">
                            <span>{ currLeader || trans['leaderboard'] }</span>
                            <span className="si-member-count">
                                {
                                    (
                                        TotalMember > 1
                                            ?
                                            common.memberNotation(TotalMember) + " "
                                            :
                                            "No "
                                    ) + (trans['members'] || "members")
                                }
                            </span>
                        </div>
                        <div className="si-common-menu">
                        </div>
                    </div>
                </div>
                <div className="si-leagues-container si-column-layout">
                    <div className="si-selectbox">
                        <div className="si-dropdown-btn">
                            <i className={ prevBtnClasses } onClick={ () => this.onPreviousTap() } />
                            <span onClick={ () => this.onDDTap() }>{ selectedLabel }</span>
                            <i className={ nextBtnClasses } onClick={ () => this.onNextTap() } />
                        </div>
                        { this.state.isDDOpen ? <OutsideNotifier handler={ () => this.onDDTap() }>
                            <ul className="si-dropdown-options">
                                { userSpecificFixtures.map((el, index) => {
                                    // const selectedLabel = el.isOverAll ? trans['overall'] :
                                    //     el.isMDID ? matchDayTrans + ' ' + el['GDID'] :
                                    //         el.isPhase ? phaseTrans + ' ' + el['PhID'] : null;
                                    // const selectedLabel = el.isOverAll
                                    // ? trans['overall']
                                    // : el.isMDID
                                    // ? trans['rd' + el['GDID']]
                                    // : el.isPhase
                                    // ? trans['ph' + el['PhID']]
                                    // : null;

                                    let selectedLabel = null
                                    if (el.isOverAll) {
                                        selectedLabel = trans['overall'] ? trans['overall'] : 'Overall';
                                    }
                                    if (el.isMDID) {
                                        selectedLabel = trans['rd' + el['GDID']]
                                            ? trans['rd' + el['GDID']]
                                            : trans['rd' + el['GDID']];
                                    }
                                    if (el.isPhase) {
                                        selectedLabel = trans['ph' + el['PhID']]
                                            ? trans['ph' + el['PhID']]
                                            : phaseTrans + ' ' + el['PhID'];
                                    }
                                    // const selectedLabel = selectedMatchDay.isOverAll
                                    // ? trans['overall']
                                    // : selectedMatchDay.isMDID
                                    // ? trans['rd' + selectedMatchDay['GDID']]
                                    // : selectedMatchDay.isPhase
                                    // ? trans['ph' + selectedMatchDay['PhID']]
                                    // : null;

                                    const isSelected = currentActiveFixture === index ? 'si-selected' : '';
                                    return <li key={ index } className={ isSelected }
                                        onClick={ () => this.onSelect(index) }>
                                        <span>{ selectedLabel }</span></li>
                                }) }
                            </ul>
                        </OutsideNotifier> : null }
                    </div>
                    <div className="si-leaderboard ">
                        <div className="si-board-head">
                            <div className="si-row si-data-row">
                                <div className="si-block si-name-wrp">
                                    <span className="si-rank">{ trans['rank'] }</span>
                                    <span className="si-plyr-info-wrap" ></span>
                                </div>
                                <div className="si-block si-right-data">
                                    <div className="si-cell"><span className="">{ columnLabel }</span></div>
                                    { selectedMatchDay.isOverAll
                                        ?
                                        <div className="si-cell"><span className="">{ trans['total'] }</span></div>

                                        : null
                                    }
                                </div>


                            </div>
                        </div>
                        <div className="si-board-body si-tBody">
                            { members.map((eachMember) => {
                                const { UserId, UserTeamId, Trend, GUID, FullName, TeamName, BadgeId, Points, Rank, GamedayPoints } = eachMember;
                                let imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
                                const trendClass = config.trend[Trend];
                                const isUserSelf = GUID === common.getGUID();
                                const wrapperClass = common.makeClasses({
                                    'si-data-row': true,
                                    'si-row': true,
                                    'si-current-user': isUserSelf
                                });
                                let handler = () => {
                                };
                                let path = ""
                                if (isUserSelf || Rank === null) {
                                    // handler = () => this.goToTeam("self");
                                    path = this.goToTeam("self");
                                } else {
                                    // handler = () => this.goToTeam(GUID, UserId, UserTeamId);
                                    path = this.goToTeam(GUID, UserId, UserTeamId);
                                }
                                const name = FullName + (isUserSelf ? ' ' + trans['you'] : '');
                                const pts = selectedMatchDay.isOverAll ? GamedayPoints :
                                    selectedMatchDay.isPhase ? Points : Points;
                                return <a href={ path } className={ wrapperClass } key={ UserId }>
                                    <div className="si-block si-name-wrp">
                                        <div className="si-rank">
                                            <span className={ trendClass }>{ (Rank || '-') }</span>
                                        </div>
                                        <div className="si-plyr-info-wrap">
                                            <div className="si-plyr-info">
                                                {/* <div className="si-badge-wrap">
                                                        <img src={imgSrc} alt={UserId} />
                                                        <div className="si-member-num">
                                                            <span>12</span>
                                                        </div>
                                                    </div> */}
                                                <div className="si-names">
                                                    <span className="si-name-one">{ TeamName }</span>
                                                    <span className="si-user-name">{ name }</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="si-block si-right-data">
                                        <div className=" si-total si-cell">{ (pts || '-') }</div>
                                        {
                                            (selectedMatchDay.isOverAll)
                                                ?
                                                <div className=" si-total si-cell">{ (Points || '-') }</div>
                                                :
                                                null
                                        }
                                    </div>
                                </a>
                            }) }

                            { areAllLoaded ? null : <a className="si-data-row si-row si-tbl-loader">
                                <div className="si-block si-name-wrp">
                                    <div className="si-loader-dots">
                                        {/* <span className="si-dots si-dot1" />
                                            <span className="si-dots si-dot2" />
                                            <span className="si-dots si-dot3" /> */}
                                        <div className="si-btn si-btn-primary" onClick={ () => this.getLeaderBoard(true) }>
                                            <span>{ trans['loadFiftyMore'] || "Load 50 more rows" }</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="si-total si-cell" />
                                <div className="si-total si-cell" />
                            </a> }

                            { !isUserInRest ? Self.map((eachMember) => {
                                const { UserId, UserTeamId, Trend, GUID, FullName, TeamName, BadgeId, GamedayPoints, Points, Rank } = eachMember;
                                const memberFoundInRest = find(Rest, (el) => {
                                    return el.GUID === common.getGUID();
                                });
                                const isUserSelf = GUID === common.getGUID();
                                if (memberFoundInRest) {
                                    return null;
                                }
                                let handler = () => {
                                };
                                let path = ""
                                if (isUserSelf || Rank === null) {
                                    // handler = () => this.goToTeam("self");
                                    path = this.goToTeam("self");
                                } else {
                                    // handler = () => this.goToTeam(GUID, UserId, UserTeamId);
                                    path = this.goToTeam(GUID, UserId, UserTeamId);
                                }
                                let imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
                                const trendClass = config.trend[Trend];
                                const wrapperClass = common.makeClasses({
                                    'si-data-row': true,
                                    'si-row': true,
                                    'si-current-user': isUserSelf
                                });
                                const pts = selectedMatchDay.isOverAll ? GamedayPoints :
                                    selectedMatchDay.isPhase ? Points : Points;
                                return <a href={ path } className={ wrapperClass } key={ UserId }>
                                    <div className="si-block si-name-wrp">
                                        <div className="si-rank">
                                            <span className={ trendClass }>{ Rank }</span>
                                        </div>
                                        <div className="si-plyr-info-wrap">
                                            <div className="si-plyr-info">
                                                {/* <div className="si-badge-wrap">
                                                        <img src={imgSrc} alt={UserId} />
                                                        <div className="si-member-num">
                                                            <span>12</span>
                                                        </div>
                                                    </div> */}
                                                <div className="si-names">
                                                    <span className="si-name-one">{ TeamName }</span>
                                                    <span className="si-user-name">{ FullName }</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="si-block si-right-data">
                                        <div className=" si-total si-cell">{ (pts || '-') }</div>
                                        {
                                            (selectedMatchDay.isOverAll)
                                                ?
                                                <div className=" si-total si-cell">{ (Points || '-') }</div>
                                                :
                                                null
                                        }
                                    </div>

                                </a>
                            }) : null }
                        </div>
                    </div>
                </div>
                <AdBottom />
            </div>
            <GeneralPopUp { ...popupPropsData } />
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getFixtures: (GamedayId) => dispatch(getFixtures(GamedayId)),
        getPublicLeagueLeaderBoardData: (opType, vPageNo, vPageChunk, vTopNo, TypeID, countryID, clubID, vPhaseId, gamedayId) => dispatch(getPublicLeagueLeaderBoardData(opType, vPageNo, vPageChunk, vTopNo, TypeID, countryID, clubID, vPhaseId, gamedayId)),
        getPublicLeagueLeaderBoardRankData: (opType, vPageNo, vPageChunk, vTopNo, TypeID, countryID, clubID, vPhaseId, gamedayId) => dispatch(getPublicLeagueLeaderBoardRankData(opType, vPageNo, vPageChunk, vTopNo, TypeID, countryID, clubID, vPhaseId, gamedayId)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        fixtures: state.formationData.fixtures,
        publicLeaderBoard: state.leaguesData.publicLeaderBoard,
        publicRankLeaderBoard: state.leaguesData.publicRankLeaderBoard,
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(PublicLeaderBoard));


// WEBPACK FOOTER //
// ./src/components/leagues/publicLeaderBoard.js